module.exports = __webpack_public_path__ + "img/32.e774f144.png";